import PropTypes from "prop-types";
import {
  Form,
  Label,
  Input,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormFeedback,
  Alert,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Loader from "./Loader";
import "react-toastify/dist/ReactToastify.css";

//redux
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { inviteTeam, resetInviteTeamStatus } from "../../store/actions";

const InviteTeamModal = ({ show, onCloseClick }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { inviteStatus, error } = useSelector((state) => ({
    inviteStatus: state.Team.inviteStatus,
    error: state.Team.inviteError,
  }));

  const [newTeamInfo, setNewTeamInfo] = useState({
    email: "",
  });

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      emailAddress: "",
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          t("team.inviteModal.invalidEmail")
        )
        .required(t("team.inviteModal.emailRequired")),
    }),
    onSubmit: (values) => {
      setNewTeamInfo(values);
      dispatch(inviteTeam(values));
    },
  });

  const showSuccessAlert = () => {
    setTimeout(() => {
      dispatch(resetInviteTeamStatus());
      setNewTeamInfo({ ...validation.initialValues });
      validation.resetForm();
    }, 3000);
  };

  const handleModalToggle = () => {
    onCloseClick();
    validation.resetForm();
  };

  return (
    <Modal
      isOpen={show}
      toggle={handleModalToggle}
      centered
      className="teams__invite-modal"
    >
      <ModalHeader toggle={handleModalToggle}>
        {t("team.inviteModal.title")}
      </ModalHeader>
      <ModalBody>
        <Form
          action="#"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          {inviteStatus === "success" && (
            <>
              <Alert color="success" className="text-center fw-semibold">
                {t("team.inviteModal.success", {
                  email: newTeamInfo.emailAddress,
                })}
              </Alert>
              {showSuccessAlert()}
            </>
          )}
          {error && (
            <Alert color="danger" className="text-center fw-semibold">
              {error}
            </Alert>
          )}
          <div className="mb-4">
            <Label for="email">{t("team.inviteModal.inviteByEmail")}</Label>
            <Input
              name="emailAddress"
              placeholder={t("team.inviteModal.emailPlaceholder")}
              type="email"
              className="form-control"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.emailAddress || ""}
              valid={
                validation.touched.emailAddress &&
                !validation.errors.emailAddress
              }
              invalid={
                validation.touched.emailAddress &&
                validation.errors.emailAddress
              }
            />
            {validation.touched.emailAddress &&
              validation.errors.emailAddress && (
                <FormFeedback>{validation.errors.emailAddress}</FormFeedback>
              )}
          </div>
          <div className="d-flex justify-content-end">
            <Button
              color="warning"
              type="submit"
              disabled={inviteStatus === "loading" ? true : false}
              className="d-flex align-items-center gap-2 text-primary"
            >
              {inviteStatus === "loading" ? (
                <Loader color="primary" size="sm"></Loader>
              ) : (
                t("team.inviteModal.sendInvitation")
              )}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

InviteTeamModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.bool,
};

export default InviteTeamModal;
